"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _duration = _interopRequireDefault(require("./duration"));

var _videoControls = require("../video-controls.effect");

const DurationCurrent = ({
  videoTag
}) => {
  const {
    time
  } = (0, _videoControls.useVideoStatus)(videoTag);
  return /*#__PURE__*/_react.default.createElement(_duration.default, {
    duration: time * 1000
  });
};

DurationCurrent.propTypes = {
  videoTag: _propTypes.default.instanceOf(global.Element)
};
DurationCurrent.defaultProps = {
  videoTag: undefined
};
var _default = DurationCurrent;
exports.default = _default;